import { Injectable, inject } from '@angular/core';
import {
  distinctUntilChanged,
  map,
  Observable,
  shareReplay,
  startWith,
} from 'rxjs';
import { Breakpoint, BREAKPOINT_QUERIES } from '@boels/models';
import { WindowRef } from '../window/window-ref';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private windowRef = inject(WindowRef);

  private readonly _breakpoint$: Observable<string>;

  constructor() {
    this._breakpoint$ = this.windowRef.resize$.pipe(
      startWith(this._getBreakpoint()),
      map(() => {
        return this._getBreakpoint();
      }),
      distinctUntilChanged(),
      shareReplay(1),
    );
  }

  /**
   * Returns currently used breakpoint of {@link Breakpoint}.
   */
  public get breakpoint$(): Observable<string> {
    return this._breakpoint$;
  }

  public get xs$(): Observable<boolean> {
    return this._breakpoint$.pipe(map((bp) => Breakpoint.XS.toString() === bp));
  }
  /**
   *  Returns Boolean Observable. True if screen width <= {@link Breakpoint.SM}
   */
  public get smAndBelow$(): Observable<boolean> {
    return this._breakpoint$.pipe(
      map((bp) =>
        [Breakpoint.XS.toString(), Breakpoint.SM.toString()].includes(bp),
      ),
    );
  }

  /**
   *  Returns Boolean Observable. True if screen width <= {@link Breakpoint.MD}
   */
  public get mdAndBelow$(): Observable<boolean> {
    return this._breakpoint$.pipe(
      map((bp) =>
        [
          Breakpoint.XS.toString(),
          Breakpoint.SM.toString(),
          Breakpoint.MD.toString(),
        ].includes(bp),
      ),
    );
  }

  private _getBreakpoint(): string {
    let newSize = 'never';
    if (this.windowRef.isBrowser()) {
      [[newSize]] = Array.from(BREAKPOINT_QUERIES.entries()).filter(
        ([, mediaQuery]) =>
          this.windowRef.nativeWindow?.matchMedia(mediaQuery).matches,
      );
    }
    return newSize;
  }
}
